import { memo, useMemo } from "react";
import { Box } from "@mui/material";

import AskomaChartSection from "./AskomaChartSection/AskomaChartSection";
import AskomaLiveSection from "./AskomaLiveSection/AskomaLiveSection";
import AskomaEnergySection from "./AskomaEnergySection/AskomaEnergySection";

import { useAskomaContext } from "../context/AskomaContext";

function AskomaMain({ viewMode, viewOffset, zoomLevel }) {
  const { measurementHistory = [] } = useAskomaContext();

  const data = useMemo(() => {
    const targetDate = new Date();

    switch (viewMode) {
      case "today": {
        targetDate.setDate(targetDate.getDate() + viewOffset);

        return measurementHistory.filter((item) => {
          const date = new Date(item.created_at);

          return (
            date.getFullYear() === targetDate.getFullYear() &&
            date.getMonth() === targetDate.getMonth() &&
            date.getDate() === targetDate.getDate()
          );
        });
      }

      case "week": {
        const startOfWeek = new Date(targetDate);
        startOfWeek.setDate(
          startOfWeek.getDate() -
            ((startOfWeek.getDay() + 6) % 7) +
            viewOffset * 7,
        );
        startOfWeek.setHours(0, 0, 0, 0);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(endOfWeek.getDate() + 7);

        return measurementHistory.filter((item) => {
          const date = new Date(item.created_at);

          return date >= startOfWeek && date < endOfWeek;
        });
      }

      case "month": {
        targetDate.setMonth(targetDate.getMonth() + viewOffset);

        return measurementHistory.filter((item) => {
          const date = new Date(item.created_at);

          return (
            date.getFullYear() === targetDate.getFullYear() &&
            date.getMonth() === targetDate.getMonth()
          );
        });
      }

      case "year": {
        const targetYear = targetDate.getFullYear() + viewOffset;

        return measurementHistory.filter((item) => {
          const date = new Date(item.created_at);

          return date.getFullYear() === targetYear;
        });
      }

      case "all":
        return measurementHistory;

      default:
        return measurementHistory;
    }
  }, [measurementHistory, viewMode, viewOffset]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <AskomaLiveSection viewMode={viewMode} viewOffset={viewOffset} />

      <AskomaEnergySection
        viewMode={viewMode}
        viewOffset={viewOffset}
        data={data}
      />

      <AskomaChartSection
        viewMode={viewMode}
        viewOffset={viewOffset}
        data={data}
        zoomLevel={zoomLevel}
      />
    </Box>
  );
}

export default memo(AskomaMain);
